<div fxLayout="column" fxLayoutAlign="center center">
    <span style="text-align: center;">
        <a style="align-items: center; cursor: pointer;" 
        class="primary-icon padding-10" (click)="sizeChart()">
            Size Chart
        </a>
    </span>
</div>